import { UpdateMode } from "realm";
import { MessageType } from "../constants/types";
import { currentRealm, getData } from "../realm";
import { UserSchema, USER_LIST, GROUP_CHAT_LIST, GROUP_SEND_MSG, GroupSendMsgSchema } from "../realm/contactSchema";
import { MESSAGE, MessageSchema } from "../realm/schema";
import { userDetail } from "./service";
import * as ImSdk from "../../imsdk/api";
import { group_send_msg_get, group_send_msg_set, group_send_msg_query, group_send_msg_delete } from "../../imsdk/db/t_group_send_msg";

/**
 * 查询用户信息，是个异步方法，本地数据库找不到就会去请求后台
 * @param uids uid数组
 * @returns userInfo
 */
export const fetchUserInfo = async (uids: number[]) => {
  const localUsers: UserSchema[] = [];
  const requestUids: number[] = [];
  uids.forEach((uid) => {
    const localUser = currentRealm().objectForPrimaryKey<UserSchema>(
      USER_LIST,
      uid
    );
    localUser ? localUsers.push(localUser) : requestUids.push(uid);
  });
  if (requestUids.length) {
    const { data } = await userDetail(requestUids);
    if (data?.users) {
      const realm = currentRealm();
      realm.write(() => {
        data.users.forEach((item) => {
          try {
            realm.create(USER_LIST, item, UpdateMode.Modified);
          } catch (e) {
            console.log("update users err", item);
          }
        });
      });

      return localUsers.concat(data.users);
    }
  }

  return localUsers;
};

export function searchGlobal(searchVal: string) {
  const chatObjList = searchFromChatList(searchVal);
  const userList = searchFromUserList(searchVal);
  const groupList = searchFromGroupList(searchVal);

  return { chatObjList, userList, groupList };
}

/**
 * 搜索会话记录
 * @param searchVal
 * @returns
 */
export function searchFromChatList(
  searchVal: string
): Map<string, MessageSchema[]> {
  const filteredMsg = getData(MESSAGE)
    // .toJSON()
    .filter((msg) => msg.content?.indexOf(searchVal) !== -1);
  // console.log('搜索的msg: ', filteredMsg);
  const chatObjList = new Map<string, MessageSchema[]>();
  let existTid: string[] = [];
  filteredMsg.forEach((msg: MessageSchema) => {
    if (!existTid.includes(msg.tid)) {
      existTid.push(msg.tid);
      chatObjList.set(msg.tid, [msg]);
    } else {
      const msgList = chatObjList.get(msg.tid);
      msgList?.push(msg);
    }
  });

  return chatObjList;
}

/**
 * 搜索指定类型的消息
 * @param type
 * @param searchVal
 * @returns
 */
export function searchFromChatType(
  type: MessageType,
  searchVal: string
): Map<string, MessageSchema[]> {
  const filteredMsg = getData(MESSAGE)
    // .toJSON()
    .filter(
      (msg) =>
        msg.type === type && msg.content?.indexOf(searchVal) !== -1
    );
  const chatObjList = new Map<string, MessageSchema[]>();
  let existTid: string[] = [];
  filteredMsg.forEach((msg: MessageSchema) => {
    if (!existTid.includes(msg.tid)) {
      existTid.push(msg.tid);
      chatObjList.set(msg.tid, [msg]);
    } else {
      const msgList = chatObjList.get(msg.tid);
      msgList?.push(msg);
    }
  });
  return chatObjList;
  // return db.getAllData("Message").then((messages) => {
  //   return messages.filter(
  //     (msg) => msg.type === type && msg.content?.indexOf(searchVal) !== -1
  //   );
  // });
}

/**
 * 从UserList表中搜索指定内容
 * @param searchVal
 * @returns
 */
export function searchFromUserList(searchVal: string) {
  if (searchVal) {
    return getData(USER_LIST)
      .filter(
        (user: any) =>
          (user.name?.indexOf(searchVal) ?? -1) !== -1 ||
          (user.position?.indexOf(searchVal) ?? -1) !== -1,
      );
  }
  return [];
}

/**
 * 从我的群聊表中搜索指定内容
 * @param searchVal
 */
export function searchFromGroupList(searchVal: string) {
  return getData(GROUP_CHAT_LIST)
    // .toJSON()
    .filter(
      (group) =>
        (group.name && group.name?.indexOf(searchVal) !== -1) ||
        (group.tag && group.tag.indexOf(searchVal) !== -1)
    );
}

/**
 * 获取在当前群聊最后一次发送时间
 */
export async function getLastSendMsg(uid: number, tid: string) {
  try {
    const db = ImSdk.getInstance().GetUserDB();
    if (!db) {
      console.warn('[getLastSendMsg] 数据库未初始化');
      return [];
    }
    
    const result = await group_send_msg_query(db, uid, tid);
    if (result.error) {
      console.error('[getLastSendMsg] 查询失败:', result.error);
      return [];
    }
    
    return result.data || [];
  } catch (error) {
    console.error('[getLastSendMsg] 异常:', error);
    return [];
  }
}

export async function setLastSendMsg({ time, uid, tid }: GroupSendMsgSchema) {
  try {
    const db = ImSdk.getInstance().GetUserDB();
    if (!db) {
      console.warn('[setLastSendMsg] 数据库未初始化');
      return;
    }
    
    const result = await group_send_msg_set(db, { tid, uid, time });
    if (result.error) {
      console.error('[setLastSendMsg] 保存失败:', result.error);
    }
  } catch (error) {
    console.error('[setLastSendMsg] 异常:', error);
  }
}

export async function delLastSendMsg(uid: number, tid: string) {
  try {
    const db = ImSdk.getInstance().GetUserDB();
    if (!db) {
      console.warn('[delLastSendMsg] 数据库未初始化');
      return;
    }
    
    // 先查询确认是否存在
    const queryResult = await group_send_msg_query(db, uid, tid);
    if (queryResult.data && queryResult.data.length > 0) {
      const result = await group_send_msg_delete(db, tid);
      if (result.error) {
        console.error('[delLastSendMsg] 删除失败:', result.error);
      }
    }
  } catch (error) {
    console.error('[delLastSendMsg] 异常:', error);
  }
}
